import { useGetMember } from '#api/member';
import { Text } from '#atoms';
import { SEX } from '#const/confirmationForms/enum';
import { SexType } from '#types/confirmationForms';
import { SearchMember } from '#types/member';
import dayjs from 'dayjs';
import {
  LectureBox,
  LectureTextWrapper,
  LectureWrapper,
  StyledImage
} from './styles';
import CustoerImage from '#assets/img/Frame_2.png';

interface ItemProps {
  person: SearchMember;
}

const Item = ({ person }: ItemProps) => {
  // 회원들의 수업 횟수를 계산하여 수업 중, 종료 임박, 종료 3가지로 나타내는 함수
  // 총 수업 횟수가 3초과이면 수업 중, 3이하면 종료 임박, 0은 종료로 표시한다.
  // 안 쓰는 코드
  // function CalculatedLecture(totalamount: number) {
  //   let color = '';
  //   let state = '';
  //   let width = '';
  //   let height = '';

  //   if (totalamount > 3) {
  //     state = '수업 중';
  //     color = '#6238dd';
  //     width = '47px';
  //     height = '24px';
  //   } else if (totalamount === 0) {
  //     state = '종료';
  //     color = '#756F7E';
  //     width = '33px';
  //     height = '24px';
  //   } else {
  //     state = '종료 임박';
  //     color = '#E13A3A';
  //     width = '57px';
  //     height = '24px';
  //   }
  //   return (
  //     <BadgeContainer
  //       bgColor={color}
  //       style={{ marginRight: '4px', width: width, height: height }}
  //     >
  //       <BadgeText>{state}</BadgeText>
  //     </BadgeContainer>
  //   );
  // }

  return (
    <LectureWrapper
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        padding: '12px 0'
      }}
    >
      <StyledImage
        src={person.profileImage ? person.profileImage : CustoerImage}
      />
      <LectureTextWrapper>
        {/* {!isPreview ? (
        <LectureBox data-text-color="gray2">
          <Text textStyle="t3">{lecture.title}</Text>
          <BoxIcon type="next-arrow" onlyIcon size={16} />
        </LectureBox>
      ) : (
        <Text textStyle="t3" textColor="gray2">
          {lecture.title}
        </Text>
      )} */}
        <Text textStyle="t3">{person.name}</Text>
        <Text textStyle="c1" textColor="gray2">
          {`${person.age}세`}
          {SEX[person.sex as keyof SexType] == '남성' ? ' · 남' : ' · 여'}
        </Text>
        <LectureBox data-text-color="gray2">
          {/* <Text>
          {person.regionSigu} {person.regionDong}
        </Text> */}
          {/* <Text>
          {calculatedRegisteredLecture.registeredLectureCount} /{' '}
          {
            calculatedRegisteredLecture.totalRegisteredLectureCount
          }
          회
        </Text> */}
        </LectureBox>
      </LectureTextWrapper>
      {/* {CalculatedLecture(calculatedRegisteredLecture.totalamount)} */}
    </LectureWrapper>
  );
};

export default Item;
